import React from "react";

let Option = ({ items, disabled, field, labelName }) => {
	return items.map((item, key) => {
		return (
			<option
				key={key}
				disabled={disabled}
				value={item[field]}
				className={item.className}
			>
				{item[labelName]}
			</option>
		);
	});
};

export default Option;
